import {
  CalendarOutlined,
  DollarOutlined,
  LoadingOutlined,
  UndoOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Button, Modal, Spin, Timeline, Tooltip } from 'antd';
import React, { useState } from 'react';

import { useOrderStatus } from '../../custom-hooks/sa-orders';
import { formatUTCTimeToLocal } from '../../utils/format';
import { StatusTimeline } from './OrderListing';

const OrderPaymentStatusTracking = ({
  record,
  onOpenChange,
}: {
  record: any;
  onOpenChange?: (open: boolean) => void;
}) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const statusQuery = useOrderStatus(record.id, visible);
  const paymentStatus = statusQuery.data?.payment || [];

  const manualRefreshData = async () => {
    setLoading(true);
    await statusQuery.refetch();
    setLoading(false);
  };
  const generalLoading = statusQuery.isLoading || loading;

  return (
    <>
      <Tooltip title="Payment Status Tracking">
        <Button
          icon={<DollarOutlined />}
          onClick={() => {
            // Close dropdown immediately when clicked
            onOpenChange?.(false);
            setVisible(true);
          }}
        >
          Payment Status
        </Button>
      </Tooltip>
      <Modal
        title={
          <span>
            Payment Status Tracking
            {generalLoading ? (
              <LoadingOutlined style={{ marginLeft: 8 }} />
            ) : (
              <UndoOutlined
                onClick={() => manualRefreshData()}
                style={{ marginLeft: 8, cursor: 'pointer' }}
              />
            )}
          </span>
        }
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        width={600}
      >
        <Spin spinning={generalLoading}>
          <StatusTimeline>
            <Timeline>
              {paymentStatus.map(statusObj => (
                <Timeline.Item
                  key={statusObj?.timestamp}
                  dot={<CalendarOutlined />}
                >
                  <strong>{statusObj?.next_status}</strong>
                  <span
                    style={{
                      display: 'block',
                      fontSize: '12px',
                      opacity: 0.8,
                      marginTop: 4,
                    }}
                  >
                    {formatUTCTimeToLocal(
                      statusObj?.timestamp,
                      'DD MMM YYYY, HH:mm (Z)'
                    )}
                  </span>
                  <Tooltip
                    title={statusObj?.user_info?.email}
                    placement="topLeft"
                  >
                    <div style={{ fontSize: '12px', marginTop: 2 }}>
                      <UserOutlined /> By {statusObj?.user_info?.full_name}
                    </div>
                  </Tooltip>
                </Timeline.Item>
              ))}
              {(!paymentStatus || paymentStatus.length === 0) && (
                <Timeline.Item>
                  <span style={{ opacity: 0.6 }}>
                    No payment history available
                  </span>
                </Timeline.Item>
              )}
            </Timeline>
          </StatusTimeline>
        </Spin>
      </Modal>
    </>
  );
};

export default OrderPaymentStatusTracking;
